import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  createInvoiceLoading: false,
  createInvoiceError: null,
  createInvoiceSuccess: false,
  invoice: {},
  getInvoiceLoading: false,
  getInvoiceError: null,
  getInvoiceSuccess: false,
  profile: {},
  getProfileLoading: false,
  getProfileError: null,
  getProfileSuccess: false,
  rates: [],
  getRatesLoading: false,
  getRatesError: null,
  getRatesSuccess: false,
  qrCode: null,
  getQRCodeLoading: false,
  getQRCodeError: null,
  getQRCodeSuccess: false,
};

const InvoiceReducer = createSlice({
  name: "Invoice",
  initialState,
  reducers: {
    createInvoiceLoading: (state) => {
      state.createInvoiceLoading = true;
      state.createInvoiceError = null;
      state.createInvoiceSuccess = false;
    },
    createInvoiceError: (state, action) => {
      state.createInvoiceLoading = false;
      state.createInvoiceError = action.payload;
      state.createInvoiceSuccess = false;
    },
    createInvoiceSuccess: (state, action) => {
      state.createInvoiceLoading = false;
      state.createInvoiceSuccess = action.payload;;
      state.createInvoiceError = false;
    },
    getInvoiceLoading: (state) => {
      state.getInvoiceLoading = true;
      state.getInvoiceError = null;
      state.getInvoiceSuccess = false;
    },
    getInvoiceError: (state, action) => {
      state.getInvoiceLoading = false;
      state.getInvoiceError = action.payload;
      state.getInvoiceSuccess = false;
      state.invoice = {};
    },
    getInvoiceSuccess: (state, action) => {
      state.getInvoiceLoading = false;
      state.getInvoiceSuccess = true;
      state.invoice = action.payload;
    },
    getProfileLoading: (state) => {
      state.getProfileLoading = true;
      state.getProfileError = null;
      state.getProfileSuccess = false;
    },
    getProfileError: (state, action) => {
      state.getProfileLoading = false;
      state.getProfileError = action.payload;
      state.getProfileSuccess = false;
      state.profile = {};
    },
    getProfileSuccess: (state, action) => {
      state.getProfileLoading = false;
      state.getProfileSuccess = true;
      state.profile = action.payload;
    },
    getRatesLoading: (state) => {
      state.getRatesLoading = true;
      state.getRatesError = null;
      state.getRatesSuccess = false;
    },
    getRatesError: (state, action) => {
      state.getRatesLoading = false;
      state.getRatesError = action.payload;
      state.getRatesSuccess = false;
      state.rates = [];
    },
    getRatesSuccess: (state, action) => {
      state.getRatesLoading = false;
      state.getRatesSuccess = true;
      state.rates = action.payload;
    },
    getQRCodeLoading: (state) => {
      state.getQRCodeLoading = true;
      state.getQRCodeError = null;
      state.getQRCodeSuccess = false;
      state.qrCode = null;
    },
    getQRCodeError: (state, action) => {
        state.getQRCodeLoading = false;
      state.getQRCodeError = action.payload;
      state.getQRCodeSuccess = false;
      state.qrCode = null;
      },
    getQRCodeSuccess: (state, action) => {
        state.getQRCodeLoading = false;
      state.getQRCodeSuccess = true;
      state.qrCode = action.payload;
      },

    clearStates: (state) => {
      state.createInvoiceError = null;
      state.createInvoiceSuccess = false;

      state.getInvoiceError = null;
      state.getInvoiceSuccess = false;

      state.getProfileError = null;
      state.getProfileSuccess = false;

      state.getRatesError = null;
      state.getRatesSuccess = false;

      state.getQRCodeError = null;
      state.getQRCodeSuccess = false;
    },

    clearAllStatesses: (state) => {
      state.createInvoiceError = null;
      state.createInvoiceSuccess = false;
      state.createInvoiceLoading = false;
      
      state.getInvoiceError = null;
      state.getInvoiceSuccess = false;
      state.getInvoiceLoading = false;

      state.getProfileError = null;
      state.getProfileSuccess = false;
      state.getProfileLoading = false;
      
      state.getRatesError = null;
      state.getRatesSuccess = false;
      state.getRatesLoading = false;

      state.getQRCodeError = null;
      state.getQRCodeSuccess = false;
      state.getQRCodeLoading = false;
      state.qrCode = null;
      state.invoice = {};
      state.profile = {};
      state.rates = [];
    },
  },
});

export const CryptoChillActions = InvoiceReducer.actions;

export default InvoiceReducer.reducer;
